// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { sortSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListSortSelect";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

sortSelectStyles.select = {
    sizeVariant: "small",
    labelProps: {
        size: 14,
        weight: fontConfig.weight.regular,
        color: "common.black",
        css: css`
            width: unset;
            padding: 0;
            letter-spacing: 0;
            line-height: 22px;
        `,
    },
    cssOverrides: {
        formField: css`
            align-items: center;
            gap: 8px;
            width: 317px;
            ${xScreen("lte", "md")} {
                width: 100%;
                flex-direction: column;
                align-items: flex-start;
            }
        `,
        formInputWrapper: css`
            flex-grow: 1;
            ${xScreen("lte", "md")} {
                width: 100%;
            }
        `,
    },
};
